import { createFileRoute } from "@tanstack/react-router";
import SimulatorFleetPage from "../../../pages/Admin/SimulatorFleetPage/SimulatorFleetPage";

export const Route = createFileRoute("/(app)/admin/simulator-fleet")({
  component: RouteComponent,
});

function RouteComponent() {
  return <SimulatorFleetPage />;
}
